var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorProLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 37,
    viewBox: "0 0 339 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.741 11.7358C216.921 11.6522 212.041 16.4997 212.107 24.055C212.041 31.6103 216.921 36.4577 223.741 36.3741C230.561 36.4577 235.475 31.6103 235.392 24.055C235.475 16.4997 230.561 11.6522 223.741 11.7358ZM223.925 32.2789H223.574C219.312 32.2789 216.738 29.1698 216.738 24.055C216.738 18.9234 219.312 15.8478 223.574 15.8478H223.925C228.187 15.8478 230.762 18.9234 230.762 24.055C230.762 29.1698 228.187 32.2789 223.925 32.2789Z",
    fill: "#18191B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.307 24.055C315.241 16.4997 320.121 11.6522 326.941 11.7358C333.761 11.6522 338.675 16.4997 338.592 24.055C338.675 31.6103 333.761 36.4577 326.941 36.3741C320.121 36.4577 315.241 31.6103 315.307 24.055ZM326.774 32.2789H327.125C331.387 32.2789 333.962 29.1698 333.962 24.055C333.962 18.9234 331.387 15.8478 327.125 15.8478H326.774C322.512 15.8478 319.937 18.9234 319.937 24.055C319.937 29.1698 322.512 32.2789 326.774 32.2789Z",
    fill: "#18191B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.313 36.0398V12.0701H305.094C309.758 12.0701 312.8 14.8616 312.8 19.6087C312.8 24.3559 309.758 27.1807 305.094 27.1807H298.926V36.0398H294.313ZM298.926 23.0688H304.576C306.916 23.0688 308.17 21.7316 308.17 19.6087C308.17 17.4859 306.916 16.1821 304.576 16.1821H298.926V23.0688Z",
    fill: "#18191B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.68 12.0701H269.14V36.0398H273.753V16.1821H284.067V36.0398H288.68V12.0701Z",
    fill: "#18191B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.688 36.0398V12.0701H250.469C255.132 12.0701 258.175 14.8616 258.175 19.6087C258.175 24.3559 255.132 27.1807 250.469 27.1807H244.301V36.0398H239.688ZM244.301 23.0688H249.951C252.291 23.0688 253.544 21.7316 253.544 19.6087C253.544 17.4859 252.291 16.1821 249.951 16.1821H244.301V23.0688Z",
    fill: "#18191B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.133 36.0398V16.1821H189.859V12.0701H211.088V16.1821H202.763V36.0398H198.133Z",
    fill: "#18191B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.577 11.7358C171.356 11.669 167.06 16.7002 167.11 24.055C167.06 31.4097 171.356 36.441 178.577 36.3741C184.744 36.4243 188.338 32.914 188.639 28.1669H184.026C183.508 30.8414 181.669 32.2789 178.744 32.2789H178.409C174.448 32.2789 171.74 29.1197 171.74 24.055C171.69 19.007 174.481 15.7976 178.409 15.8478H178.744C181.635 15.8478 183.508 17.3354 184.026 19.943H188.639C188.355 15.3797 184.711 11.669 178.577 11.7358Z",
    fill: "#18191B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.249 36.0398V12.0701H164.385V16.1821H150.863V21.6981H162.329V25.8101H150.863V31.9279H164.736V36.0398H146.249Z",
    fill: "#18191B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.416 12.0701V36.0398H134.365C138.727 36.1067 141.953 33.2316 141.903 29.6713C141.903 26.5121 139.914 24.4227 137.34 23.8878C138.56 23.5368 139.53 22.8682 140.265 21.882C141.017 20.8958 141.385 19.6923 141.385 18.2715C141.435 14.8616 138.51 12.02 134.03 12.0701H123.416ZM133.345 21.8987H128.03V16.1821H133.345C135.568 16.1821 136.772 17.1516 136.772 19.0237C136.772 20.8958 135.568 21.8987 133.345 21.8987ZM133.679 31.9278H128.03V25.8769H133.679C135.953 25.8769 137.273 26.8798 137.273 28.8857C137.273 30.8915 135.953 31.9278 133.679 31.9278Z",
    fill: "#18191B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1093 36.0398V12.0701H102.723V21.999H113.17V12.0701H117.8V36.0398H113.17V26.111H102.723V36.0398H98.1093Z",
    fill: "#18191B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4762 12.0701H86.793L76.6134 29.7382V12.0701H72V36.0398H77.6498L87.8461 18.3551V36.0398H92.4762V12.0701Z",
    fill: "#18191B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.5781C0 13.4952 0.895428 12.6173 1.99999 12.6173H12V24.3821H0V14.5781Z",
    fill: "url(#paint0_linear_21598_22063)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 24.3822H12V36.147H1.99999C0.895428 36.147 0 35.2691 0 34.1862V24.3822Z",
    fill: "url(#paint1_linear_21598_22063)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M24 14.5781C24 13.4952 23.1045 12.6173 22 12.6173H12V24.3821H24V14.5781Z",
    fill: "url(#paint2_linear_21598_22063)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24 24.3822H12V36.147H22C23.1045 36.147 24 35.2691 24 34.1862V24.3822Z",
    fill: "url(#paint3_linear_21598_22063)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.81334C18 1.73042 18.8954 0.852539 20 0.852539H51.9999C53.1045 0.852539 53.9999 1.73042 53.9999 2.81334V34.1862C53.9999 35.2691 53.1045 36.147 51.9999 36.147H20C18.8954 36.147 18 35.2691 18 34.1862V2.81334Z",
    fill: "url(#paint4_linear_21598_22063)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.81334C18 1.73042 18.8954 0.852539 20 0.852539H51.9999C53.1045 0.852539 53.9999 1.73042 53.9999 2.81334V34.1862C53.9999 35.2691 53.1045 36.147 51.9999 36.147H20C18.8954 36.147 18 35.2691 18 34.1862V2.81334Z",
    fill: "url(#paint5_linear_21598_22063)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.81334C18 1.73042 18.8954 0.852539 20 0.852539H51.9999C53.1045 0.852539 53.9999 1.73042 53.9999 2.81334V34.1862C53.9999 35.2691 53.1045 36.147 51.9999 36.147H20C18.8954 36.147 18 35.2691 18 34.1862V2.81334Z",
    fill: "url(#paint6_linear_21598_22063)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 27.3235L27.9995 25.8529L41.4995 12.6174C41.6836 12.4369 41.4674 12.1429 41.2346 12.2571L40.821 12.4598C40.6096 12.5635 40.3764 12.6174 40.14 12.6174H29.9995V10.6566H44.9995V25.3627H42.9995V15.4208C42.9995 15.1891 43.0545 14.9605 43.1602 14.7532L43.367 14.3477C43.4834 14.1195 43.1836 13.9075 42.9995 14.088L29.4995 27.3235Z",
    fill: "#D9D9D9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 27.3235L27.9995 25.8529L41.4995 12.6174C41.6836 12.4369 41.4674 12.1429 41.2346 12.2571L40.821 12.4598C40.6096 12.5635 40.3764 12.6174 40.14 12.6174H29.9995V10.6566H44.9995V25.3627H42.9995V15.4208C42.9995 15.1891 43.0545 14.9605 43.1602 14.7532L43.367 14.3477C43.4834 14.1195 43.1836 13.9075 42.9995 14.088L29.4995 27.3235Z",
    fill: "url(#paint7_linear_21598_22063)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 27.3235L27.9995 25.8529L41.4995 12.6174C41.6836 12.4369 41.4674 12.1429 41.2346 12.2571L40.821 12.4598C40.6096 12.5635 40.3764 12.6174 40.14 12.6174H29.9995V10.6566H44.9995V25.3627H42.9995V15.4208C42.9995 15.1891 43.0545 14.9605 43.1602 14.7532L43.367 14.3477C43.4834 14.1195 43.1836 13.9075 42.9995 14.088L29.4995 27.3235Z",
    fill: "url(#paint8_linear_21598_22063)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.147H22C23.1046 36.147 24 35.2691 24 34.1862V14.5781C24 13.4952 23.1046 12.6173 22 12.6173H18V34.1862C18 35.2691 18.8954 36.147 20 36.147Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.147H22C23.1046 36.147 24 35.2691 24 34.1862V14.5781C24 13.4952 23.1046 12.6173 22 12.6173H18V34.1862C18 35.2691 18.8954 36.147 20 36.147Z",
    fill: "url(#paint9_linear_21598_22063)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21598_22063",
    x1: 5.99998,
    y1: 12.6173,
    x2: 5.99998,
    y2: 36.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21598_22063",
    x1: 5.99998,
    y1: 12.6174,
    x2: 5.99998,
    y2: 36.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21598_22063",
    x1: 18,
    y1: 12.6173,
    x2: 18,
    y2: 36.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21598_22063",
    x1: 18,
    y1: 12.6174,
    x2: 18,
    y2: 36.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21598_22063",
    x1: 36,
    y1: 0.852539,
    x2: 36,
    y2: 36.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21598_22063",
    x1: 36,
    y1: 0.852539,
    x2: 36,
    y2: 36.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_21598_22063",
    x1: 36,
    y1: 0.852539,
    x2: 36,
    y2: 36.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565E67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_21598_22063",
    x1: 36.4995,
    y1: 10.6566,
    x2: 36.4995,
    y2: 27.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_21598_22063",
    x1: 36.4995,
    y1: 14.1823,
    x2: 36.4995,
    y2: 25.7209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA0B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_21598_22063",
    x1: 35.9999,
    y1: 12.6173,
    x2: 35.9999,
    y2: 36.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2E00",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorProLogoNew);
export default __webpack_public_path__ + "static/media/InvestorProLogoNew.f747dbf0277027db34b2cb0e64b48a3e.svg";
export { ForwardRef as ReactComponent };